
//utf8


export const getUTF_8 = (name) => {

  var originalString = decodeURIComponent(escape(name));
  return originalString;
};
//date
export const getDate = (date) => {
  var timeShow = new Date(date);
  var options = { day: "2-digit", month: "2-digit", year: "numeric" };
  return timeShow.toLocaleDateString("en-GB", options);
};
//time
export const getTimeddmmyyyyCachHHmm = (time) => {
  var timeShow = new Date(time);
  var options = { hour: "2-digit", minute: "2-digit", hour12: false };
  return timeShow.toLocaleTimeString("en-GB", options);
};

//cout time
export const tongTime = (thoiGianVao, thoiGianRa) => {
  let hhmm = "";

  // Create Date objects and set the entry and exit times
  // const dateVao = new Date(thoiGianVao);
  // const dateRa = new Date(thoiGianRa);
  // Calculate the time difference
  const diffMillis = thoiGianRa - thoiGianVao;
  const diffHours = Math.floor(diffMillis / (60 * 60 * 1000));
  const diffMinutes = Math.floor((diffMillis / (60 * 1000)) % 60);
  hhmm = `${diffHours} : ${diffMinutes}`;
  return hhmm;
}
//encode
export const decodeBase64 = (decodedString) => {
  return atob(decodedString);
}
//lay bai viet
import { apiChiTietBaiViet, service_BaiViet, SERVICE_DANGNHAP_VID, service_DanhMuc, service_laydanhmuc, service_laydanhsachBaiViet } from "@/components/listService";
import axios from "axios";
import { MD5 } from "crypto-js";
import { apiVpos } from "./js/api";
export const performPostRequestBaiVietVpass = async (idBaiViet) => {
  try {
    // Thực hiện POST request
    const response = await axios.post(
      apiChiTietBaiViet,
      {
        id: idBaiViet,
        langId: "0",
      }
    );

    var base64 = response.data.result.content_vi;
    var base64Title_vi = response.data.result.title_vi;

    var title_vi = atob(base64Title_vi);
    this.title_vi = decodeURIComponent(escape(title_vi));

    var decodedString = atob(base64);
    this.decodedString = decodeURIComponent(escape(decodedString));

  } catch (error) {
    console.error("Error:", error);
  }
}

export const postLoginPhone = (user, pass) => {
  let data = {
    user: user,
    pass: pass,
    appId: 5,
    VimassMH: 1,
    type: 1,
  };
  const resLogin = axios.post(SERVICE_DANGNHAP_VID, data);
  return resLogin
    .then((response) => {

      if (response.data) {
        return response.data;
      } else {
        throw new Error("Login failed: " + response.data);
      }
    })

};

export const postListCateBaiViet = (limit, offset, langId) => {
  let data = {
    limit: limit,
    offset: offset,
    langId: langId,

  };
  const resLogin = axios.post(service_laydanhmuc, data);
  return resLogin
    .then((response) => {

      if (response.data) {
        return response.data;
      } else {
        throw new Error("service_laydanhmuc " + response.data);
      }
    })

};
export const postListBaiViet = (limit, offset, langId) => {
  let data = {
    limit: limit,
    offset: offset,
    langId: langId,

  };
  const resLogin = axios.post(service_laydanhsachBaiViet, data);
  return resLogin
    .then((response) => {

      if (response.data) {
        return response.data;
      } else {
        throw new Error("service_laydanhsachBaiViet " + response.data);
      }
    })

};

export const postCreateCate = (user, title_vi, title_en, pos, token, typeAuthenticate) => {
  let data = {
    user: user,
    title_vi: b64EncodeUnicode(title_vi),
    title_en: title_en,
    pos: parseInt(pos),
    token: token,
    typeAuthenticate: typeAuthenticate,

  };
  console.log("data create cate ", data);

  const resLogin = axios.post(service_DanhMuc + 'create', data);
  return resLogin
    .then((response) => {

      if (response.data) {
        return response.data;
      } else {
        throw new Error("service_laydanhmuc " + response.data);
      }
    })

};


export const postCreateBaiViet = (user, title_vi, title_vi_short, img_vi, shortContent_vi, content_vi,
  title_en, img_en, shortContent_en, content_en, token, catParam) => {
  console.log("content_vi ", content_vi);
  let data = {
    user: user,
    title_vi: b64EncodeUnicode(title_vi),
    title_vi_short: title_vi_short,
    img_vi: img_vi,
    shortContent_vi: b64EncodeUnicode(shortContent_vi),
    content_vi: b64EncodeUnicode(content_vi),

    title_en: title_en,
    img_en: img_en,
    shortContent_en: b64EncodeUnicode(shortContent_en),
    content_en: b64EncodeUnicode(content_en),

    title_kr: "",
    img_kr: "",
    shortContent_kr: "",
    content_kr: "",

    title_cn: "",
    img_cn: "",
    shortContent_cn: "",
    content_cn: "",

    title_hu: "",
    img_hu: "",
    shortContent_hu: "",
    content_hu: "",

    title_hi: "",
    img_hi: "",
    shortContent_hi: "",
    content_hi: "",

    catParam: catParam,
    pos: 0,
    typeAuthenticate: 0,
    token: token,

  };
  console.log("tao bai viet post: ", data);

  const resLogin = axios.post(service_BaiViet + 'create', data);
  console.log("aaaa ", resLogin);
  
  return resLogin
    .then((response) => {

      if (response.data) {
        return response.data;
      } else {
        throw new Error("service_BaiViet " + response.data);
      }
    })

};



export const postUpdateBaiViet = (user, title_vi, title_vi_short, img_vi, shortContent_vi, content_vi,
  title_en, img_en, shortContent_en, content_en, token, catParam, id) => {
  console.log("content_vi ", content_vi);
  let data = {
    id: id,
    user: user,
    title_vi: b64EncodeUnicode(title_vi),
    title_vi_short: title_vi_short,
    img_vi: img_vi,
    shortContent_vi: b64EncodeUnicode(shortContent_vi),
    content_vi: b64EncodeUnicode(content_vi),

    title_en: title_en,
    img_en: img_en,
    shortContent_en: b64EncodeUnicode(shortContent_en),
    content_en: b64EncodeUnicode(content_en),

    title_kr: "",
    img_kr: "",
    shortContent_kr: "",
    content_kr: "",

    title_cn: "",
    img_cn: "",
    shortContent_cn: "",
    content_cn: "",

    title_hu: "",
    img_hu: "",
    shortContent_hu: "",
    content_hu: "",

    title_hi: "",
    img_hi: "",
    shortContent_hi: "",
    content_hi: "",

    catParam: catParam,
    pos: 0,
    typeAuthenticate: 0,
    token: token,

  };
  console.log("sua bai viet post: ", data);

  const resLogin = axios.post(service_BaiViet + 'edit', data);
  return resLogin
    .then((response) => {

      if (response.data) {
        return response.data;
      } else {
        throw new Error("service_BaiViet " + response.data);
      }
    })

};
export const postDeleteBaiViet = (user, id, token) => {
  let data = {
    user: user,
    id: id,
    token: token,
    typeAuthenticate: 0,

  };
  console.log("data create cate ", data);

  const resLogin = axios.post(service_BaiViet + 'delete', data);
  return resLogin
    .then((response) => {

      if (response.data) {
        return response.data;
      } else {
        throw new Error("service_BaiViet " + response.data);
      }
    })

};



export const postListNhomKD = (limit, offset, idLogin, sessionLogin) => {
  let funcId = 120;
  let timeRequest = new Date().getTime()
  let cks = MD5("0819226669jdqpowrifioefiqo3289r79f" + sessionLogin + funcId + 3 + idLogin + timeRequest + limit + offset).toString();
  let data = {
    funcId: funcId,

    limit: limit,
    offset: offset,
    idLogin: idLogin,
    sessionLogin: sessionLogin,
    deviceOS: 3,
    timeRequest: timeRequest,
    cksInput: cks,
    sort: ""

  };

  const resLogin = axios.post(apiVpos, data);
  return resLogin
    .then((response) => {

      if (response.data) {
        return response.data;
      } else {
        throw new Error("postListNhomKD " + response.data);
      }
    })

};

export const postTaoNhomKD = (tenNhom, themNhomToken, idLogin, sessionLogin) => {
  let funcId = 121;
  let timeRequest = new Date().getTime();
  let tenNhomKhongDau = boDauTiengViet(tenNhom);
  let cks = MD5("0819226669jdqpowrifioefiqo3289r79f" +
    sessionLogin +
    funcId +
    3 +
    idLogin +
    timeRequest +
    tenNhomKhongDau).toString();
  let data = {
    funcId: funcId,
    tenNhom: tenNhom,
    idLogin: idLogin,
    sessionLogin: sessionLogin,
    deviceOS: 3,
    timeRequest: timeRequest,
    cksInput: cks,
    token: themNhomToken,

  };
  console.log(JSON.stringify(data));

  const resLogin = axios.post(apiVpos, data);
  return resLogin
    .then((response) => {

      if (response.data) {
        return response.data;
      } else {
        throw new Error("postTaoNhomKD " + response.data);
      }
    })

};


export const postSuaNhomKD = (idNhom, tenNhom, themNhomToken, idLogin, sessionLogin) => {
  let funcId = 122;
  let timeRequest = new Date().getTime();
  let tenNhomKhongDau = boDauTiengViet(tenNhom);
  let cks = MD5("0819226669jdqpowrifioefiqo3289r79f" +
    sessionLogin +
    funcId +
    3 +
    idLogin +
    timeRequest +
    tenNhomKhongDau).toString();
  console.log("id " + idNhom);

  let data = {
    funcId: funcId,
    tenNhom: tenNhom,
    idLogin: idLogin,
    sessionLogin: sessionLogin,
    deviceOS: 3,
    timeRequest: timeRequest,
    cksInput: cks,
    token: themNhomToken,
    id: idNhom,       // id nhóm cần sửa

  };

  const resLogin = axios.post(apiVpos, data);
  return resLogin
    .then((response) => {

      if (response.data) {
        return response.data;
      } else {
        throw new Error("postSuaNhomKD " + response.data);
      }
    })

};

export const postXoaNhomKD = (idS, token, idLogin, sessionLogin) => {
  let funcId = 123;
  let timeRequest = new Date().getTime();
  let id = Array.isArray(idS) ? idS : [idS]
  console.log("0819226669jdqpowrifioefiqo3289r79f" 
    + sessionLogin + funcId + 3 + idLogin	+ timeRequest +" _  "+ idS.length);
  
  let cks = MD5("0819226669jdqpowrifioefiqo3289r79f" + sessionLogin + funcId + 3 + idLogin	+ timeRequest + id.length).toString();
  let data = {
    funcId: funcId,
    idLogin: idLogin,
    sessionLogin: sessionLogin,
    deviceOS: 3,
    timeRequest: timeRequest,
    cksInput: cks,
    token:token,
    idS: id,
  };
  console.log("data xoa nhom kd ", data);
  const resLogin = axios.post(apiVpos, data);
  return resLogin
    .then((response) => {

      if (response.data) {
        return response.data;
      } else {
        throw new Error("postXoaNhomKD " + response.data);
      }
    })

};

// danh sach nv theo nhom kd

export const postListNVNhomKD = (limit, offset, idLogin, sessionLogin, maNhom) => {
  let funcId = 130;
  let timeRequest = new Date().getTime()
  let cks = MD5("jdqpowrifioefiqo3289r79f" + sessionLogin + funcId + 3 + idLogin + timeRequest + limit + offset + maNhom).toString();
  let data = {
    funcId: funcId,
    sessionLogin: sessionLogin,
    idLogin: idLogin,
    deviceOS: 3,
    timeRequest: timeRequest,
    cksInput: cks,
    maNhom: maNhom,
    limit: limit,
    offset: offset,
    sort: "desc",

  };
  // console.log(JSON.stringify(data));

  const resLogin = axios.post(apiVpos, data);
  return resLogin
    .then((response) => {

      if (response.data) {
        // console.log("postListNhomKD " , response.data);
        
        return response.data;
      } else {
        throw new Error("postListNhomKD " + response.data);
      }
    })

};


// ds cửa hàng theo nhóm kd
export const postListCuaHangNVTaoKD = (limit, offset, idLogin, sessionLogin, maNhom, idTVNhom) => {
  let funcId = 140;
  let timeRequest = new Date().getTime()
  
  let cks = MD5("0819226669jdqpowrifioefiqo3289r79f" + sessionLogin + funcId + 3 + idLogin + timeRequest + limit + offset).toString();
  let data = {
    funcId: funcId,
    sessionLogin: sessionLogin,
    idLogin: idLogin,
    deviceOS: 3,
    timeRequest: timeRequest,
    cksInput: cks,
    maNhom: maNhom,
    limit: limit,
    offset: offset,
    sort: "desc",
    idTVNhom: idTVNhom,
    sortBy: ""
  };
// console.log("data ", JSON.stringify(data));
  const resLogin = axios.post(apiVpos, data);
  return resLogin
    .then((response) => {

      if (response.data) {
        // console.log("postListCuaHangNVTaoKD ", response.data);

        return response.data;

      } else {
        throw new Error("postListCuaHangNVTaoKD " + response.data);
      }
    })

};



// ds cửa hàng theo nhóm kd
export const postListGiaoDichCuaHangNVTaoKD = (limit, offset, idLogin, sessionLogin, maNhom, idTVNhom, maQR, idStore, timeFrom, timeTo) => {
  let funcId = 195;
  let timeRequest = new Date().getTime();
  let typeLogin = 0;
  let typeSK = 1;
  let cks = MD5("0819226669jdqpowrifioefiqo3289r79f" + sessionLogin + idLogin + typeLogin + timeRequest 
					+ maQR + idStore + typeSK + timeFrom + timeTo + offset + limit + 3).toString();
  let data = {
    funcId: funcId,
    sessionLogin: sessionLogin,
    idLogin: idLogin,
    deviceOS: 3,
    timeRequest: timeRequest,
    cksInput: cks,
    maNhom: maNhom,
    limit: limit,
    offset: offset,
    sort: "desc",
    idTVNhom: "",
    sortBy: "", 
    maQR: maQR,
    idStore: idStore, 
    typeLogin: typeLogin,
    typeSK: typeSK,
    timeFrom: timeFrom,
    timeTo: timeTo,

  };
  console.log(JSON.stringify(data));

  const resLogin = axios.post(apiVpos, data);
  return resLogin
    .then((response) => {
       

      if (response.data) {
           console.log("postListCuaHangNVTaoKD " , response.data);

        return response.data;
      } else {
        throw new Error("postListCuaHangNVTaoKD " + response.data);
      }
    })

};





export const boDauTiengViet = (str) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D");
}

export const b64EncodeUnicode = (str) => {
  // Trước tiên mã hóa str thành UTF-8, sau đó mã hóa thành Base64
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}


export const decodeBase64Utf8 = (str) => {
  console.log("str ", str);

  try {
    if (!str || typeof input !== "string") return "";

    // Giải mã base64 -> binary string 
    console.log("str ", str);
    const binary = atob(str);
    console.log("binary ", binary);

    // Chuyển binary -> Uint8Array -> UTF-8 string
    const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  } catch (e) {
    return "";
  }
}